export default "__VITE_ASSET__Ctrg92Dn__"